// Import Images
import user1 from "../../assets/images/users/user-1.jpg";
import user2 from "../../assets/images/users/user-2.jpg";
import user3 from "../../assets/images/users/user-3.jpg";
import user4 from "../../assets/images/users/user-4.jpg";
import user5 from "../../assets/images/users/user-5.jpg";
import user6 from "../../assets/images/users/user-6.jpg";
import user7 from "../../assets/images/users/user-7.jpg";
import user8 from "../../assets/images/users/user-8.jpg";

import img1 from "../../assets/images/small/img-1.jpg";
import img2 from "../../assets/images/small/img-2.jpg";
import img3 from "../../assets/images/small/img-3.jpg";
import img4 from "../../assets/images/small/img-4.jpg";
import img5 from "../../assets/images/small/img-5.jpg";
import img6 from "../../assets/images/small/img-6.jpg";

const tasks = [
  {
    id: "1",
    name: "Upcoming",
    cards: [
      {
        id: "1",
        title: "Topnav Layout Design",
        date: "14 Oct, 2019",
        badgeText: "Waiting",
        badgeColor: "secondary",
        budget: "145",
        taskdesc: "Create banbun board",
        userImage: user4,
      },
      {
        id: "2",
        title: "Create a New Landing UI",
        date: "15 Oct, 2021",
        badgeText: "Approved",
        badgeColor: "primary",
        taskdesc: "Separate existence is a myth.",
        budget: "112",
        userImage: user1,
      },
      {
        id: "3",
        title: "Create a Skote Logo",
        date: "15 Oct, 2019",
        badgeText: "Waiting",
        badgeColor: "secondary",
        budget: "86",
        taskdesc: "Solved issue",
        userImage: user5,
      },
    ],
  },
  {
    id: "4",
    name: "In Progress",
    cards: [
      {
        id: "5",
        title: "Brand Logo Design",
        date: "12 Oct, 2019",
        badgeText: "Complete",
        badgeColor: "success",
        budget: "132",
        taskdesc: "Design logo",
        userImage: user7,
        brandLogo: [img1, img2, img3],
      },
      {
        id: "6",
        title: "Create a Blog Template UI",
        date: "13 Oct, 2019",
        badgeText: "Pending",
        badgeColor: "warning",
        budget: "103",
        taskdesc: "Create a blog",
        userImage: user6,
      },
      {
        id: "7",
        title: "Product Catalog Page UI",
        date: "13 Oct, 2019",
        badgeText: "Pending",
        badgeColor: "warning",
        budget: "103",
        taskdesc: "Develop catalog layout",
        userImage: user4,
      },
    ],
  },
  {
    id: "8",
    name: "Completed",
    cards: [
      {
        id: "9",
        title: "Redesign - Landing Page",
        date: "10 Oct, 2019",
        badgeText: "Complete",
        badgeColor: "success",
        budget: "145",
        taskdesc: "Redesign - Landing",
        userImage: user1,
      },
      {
        id: "10",
        title: "Multipurpose Landing",
        date: "09 Oct, 2019",
        badgeText: "Complete",
        badgeColor: "success",
        budget: "92",
        taskdesc: "Create a multipurpose landing",
        userImage: user4,
        brandLogo: [img4, img5, img6],
      },
      {
        id: "11",
        title: "Skote Landing PSD",
        date: "15 Oct, 2019",
        badgeText: "Waiting",
        badgeColor: "secondary",
        budget: "86",
        taskdesc: "Testing Skote landing",
        userImage: user7,
      },
    ],
  },
];

const AddTeamMember = [
  { id: 1, img: user1, name: "Albert Rodarte" },
  { id: 2, img: user2, name: "Hannah Glover" },
  { id: 3, img: user3, name: "Adrian Rodarte" },
  { id: 4, img: user4, name: "Frank Hamilton" },
  { id: 5, img: user5, name: "Justin Howard" },
  { id: 6, img: user6, name: "Michael Lawrence" },
  { id: 7, img: user7, name: "Oliver Sharp" },
  { id: 8, img: user8, name: "Richard Simpson" },
];

export { tasks, AddTeamMember };
